export const topics = [
  {
    id: "topic-city-walk",
    title: "城市漫步计划：重新发现身边的街巷",
    summary: "用脚步丈量城市，从老建筑到街角小店，记录那些被日常忽略的城市细节与人文温度。",
    categoryId: "life",
    cover:
      "https://readdy.ai/api/search-image?query=city%20walking%20street%20scene%20with%20narrow%20old%20lanes%20warm%20afternoon%20sunlight%20and%20small%20shops%20with%20awning%2C%20warm%20orange%20tones%2C%20documentary%20editorial%20photography%2C%20clean%20composition%2C%20high%20detail&width=800&height=600&seq=topic-citywalk-01&orientation=landscape",
    date: "2026-10-08",
    hot: 98,
  },
  {
    id: "topic-heritage",
    title: "非遗新生：传统手艺的当代打开方式",
    summary: "当老手艺遇上新设计，非遗如何走进年轻人的生活？我们走访多位传承人寻找答案。",
    categoryId: "culture",
    cover:
      "https://readdy.ai/api/search-image?query=traditional%20chinese%20intangible%20heritage%20craftsmanship%20workshop%20with%20artisan%20hands%20working%20on%20embroidery%20and%20colored%20threads%2C%20warm%20red%20and%20amber%20tones%2C%20editorial%20photography%2C%20clean%20minimal%20background%2C%20high%20detail&width=800&height=600&seq=topic-heritage-01&orientation=landscape",
    date: "2026-09-26",
    hot: 92,
  },
  {
    id: "topic-screen",
    title: "年度剧集观察：小荧幕里的大时代",
    summary: "盘点本年度最值得回味的影视作品，聊聊镜头语言、叙事结构与那些被反复讨论的角色。",
    categoryId: "entertainment",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20moody%20film%20set%20with%20projector%20light%20and%20theater%20seats%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20creative%20editorial%20photography%2C%20clean%20dark%20minimal%20background%2C%20high%20detail&width=800&height=600&seq=topic-screen-01&orientation=landscape",
    date: "2026-09-15",
    hot: 88,
  },
  {
    id: "topic-slowlife",
    title: "慢生活提案：把日子过成自己喜欢的节奏",
    summary: "断舍离、早睡、自己做饭……一份关于如何找回生活掌控感的实用提案合集。",
    categoryId: "life",
    cover:
      "https://readdy.ai/api/search-image?query=slow%20living%20calm%20morning%20scene%20with%20linen%20curtain%20sunlight%20coffee%20and%20open%20notebook%20on%20wooden%20table%2C%20soft%20warm%20beige%20tones%2C%20minimal%20editorial%20photography%2C%20clean%20background%2C%20high%20detail&width=800&height=600&seq=topic-slowlife-01&orientation=landscape",
    date: "2026-09-02",
    hot: 81,
  },
];